var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg22(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "338.67mm",
    height: "198.82mm",
    viewBox: "0 0 338.67 198.82",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath14166"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 1.2207e-4h960v540h-960z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath14232"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1.5259e-5 540h960v-540l-960 6.1035e-5",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath14242"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1.5259e-5 540h960v-540l-960 6.1035e-5",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath14252"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-3.0518e-5 540h960v-540l-960-6.1035e-5",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath14262"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-3.0518e-5 540h960v-540l-960-6.1035e-5",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath14292"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m191.44 291.05 56.25-44.95-44.95-56.24-56.25 44.95z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath14302"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath14318"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m373.53 312.58 15.59-58.38-58.38-15.59-15.59 58.38z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath14328"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath14338"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m90.75 377.25h72v72h-72z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath14348"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath14382"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.0518e-5 540h960v-540l-960 6.1035e-5",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath14392"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.0518e-5 540h960v-540l-960 6.1035e-5",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath14402"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-6.1035e-5 540h960v-540h-960",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath14412"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-6.1035e-5 540h960v-540h-960",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath14422"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-4.5776e-5 540h960v-540h-960",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath14432"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-4.5776e-5 540h960v-540h-960",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath14442"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-6.1035e-5 540h960v-540l-960-6.1035e-5",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath14452"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-6.1035e-5 540h960v-540l-960-6.1035e-5",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath14462"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m566.25 86.25h58.5v58.5h-58.5z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath14472"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath14482"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m413.25 73.5h72v72h-72z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath14492"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath14508"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m286.5 77.25h72v72h-72z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath14518"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath14534"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m165 71.25h72v72h-72z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath14544"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath14566"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 540h960v-540l-960 6.1035e-5",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath14576"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 540h960v-540l-960 6.1035e-5",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath14586"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m533.25 6.1035e-5h72v66h-72z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath14596"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath14606"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m595.8 75.003 71.11-11.335-10.15-63.668h-47.82l-24.47 3.9013z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath14616"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath14626"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m116.25 1.2207e-4h72v67.5h-72z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath14636"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(95.227 -51.786)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.35278 0 0 -.35278 -95.227 242.29)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h960v540h-960z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.75893 0 0 1.0437 70.714 -23.571)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath14166)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 6.1035e-5h960v540h-960z",
    fill: "#fff",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m139.13 67.875 18.37 73.495h464.25l18.38-73.495z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m139.13 67.875 18.37 73.495h464.25l18.38-73.495z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m222.38 264c0 27.96 22.66 50.62 50.62 50.62s50.63-22.66 50.63-50.62-22.67-50.63-50.63-50.63-50.62 22.67-50.62 50.63z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m222.38 264c0 27.96 22.66 50.62 50.62 50.62s50.63-22.66 50.63-50.62-22.67-50.63-50.63-50.63-50.62 22.67-50.62 50.63z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m250.88 190.87h17.25v45h-17.25z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m250.88 190.87h17.25v45h-17.25z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m278.63 190.87h17.25v45h-17.25z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m278.63 190.87h17.25v45h-17.25z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m244.88 274.5c0 8.91 7.55 16.12 16.87 16.12s16.88-7.21 16.88-16.12-7.56-16.13-16.88-16.13-16.87 7.22-16.87 16.13z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m244.88 274.5c0 8.91 7.55 16.12 16.87 16.12s16.88-7.21 16.88-16.12-7.56-16.13-16.88-16.13-16.87 7.22-16.87 16.13z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m268.13 274.5c0 8.91 7.55 16.12 16.87 16.12s16.88-7.21 16.88-16.12-7.56-16.13-16.88-16.13-16.87 7.22-16.87 16.13z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m268.13 274.5c0 8.91 7.55 16.12 16.87 16.12s16.88-7.21 16.88-16.12-7.56-16.13-16.88-16.13-16.87 7.22-16.87 16.13z",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m264.78 272.32c0-1.07-0.87-1.95-1.95-1.95s-1.95 0.88-1.95 1.95c0 1.08 0.87 1.95 1.95 1.95s1.95-0.87 1.95-1.95z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m283.71 272.52c0-1.08-0.87-1.95-1.94-1.95-1.08 0-1.95 0.87-1.95 1.95s0.87 1.95 1.95 1.95c1.07 0 1.94-0.87 1.94-1.95z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m246.38 308.62 25.5 49.5 25.5-49.5z",
    fill: "#4472c4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m246.38 308.62 25.5 49.5 25.5-49.5z",
    fill: "none",
    stroke: "#2f528f",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath14232)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m228.31 261.1-13.32-4.77c-7.35-2.63-14.61-1.14-16.21 3.33s3.06 10.23 10.42 12.86l13.31 4.77z",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath14242)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m228.31 261.1-13.32-4.77c-7.35-2.63-14.61-1.14-16.21 3.33s3.06 10.23 10.42 12.86l13.31 4.77z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath14252)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m308.07 269.87 16.44 10.59c9.07 5.85 19.01 6.58 22.2 1.64 3.19-4.95-1.59-13.7-10.66-19.55l-16.43-10.59z",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath14262)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m308.07 269.87 16.44 10.59c9.07 5.85 19.01 6.58 22.2 1.64 3.19-4.95-1.59-13.7-10.66-19.55l-16.43-10.59z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "m258.38 241.5c0 3.94 5.37 7.12 12 7.12 6.62 0 12-3.18 12-7.12s-5.38-7.13-12-7.13c-6.63 0-12 3.19-12 7.13z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m258.38 241.5c0 3.94 5.37 7.12 12 7.12 6.62 0 12-3.18 12-7.12s-5.38-7.13-12-7.13c-6.63 0-12 3.19-12 7.13z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m372.38 461.75c0 18.98 15.39 34.37 34.37 34.37h334c18.98 0 34.38-15.39 34.38-34.37v-137.5c0-18.98-15.4-34.38-34.38-34.38h-334c-18.98 0-34.37 15.4-34.37 34.38z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m372.38 461.75c0 18.98 15.39 34.37 34.37 34.37h334c18.98 0 34.38-15.39 34.38-34.37v-137.5c0-18.98-15.4-34.38-34.38-34.38h-334c-18.98 0-34.37 15.4-34.37 34.38z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath14292)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-.78119 .6243 -.6243 -.78119 247.69 246.1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath14302)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m42.384 46.866h11.25v1.5h-11.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.384 42.366h11.25v1.5h-11.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.384 37.866h7.5v1.5h-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m65.634 54.366h-4.5v3.3c0 0.32-0.203 0.605-0.506 0.709-7.864 2.625-16.363 2.654-24.244 0.083-7.881 2.572-16.38 2.543-24.244-0.082-0.303-0.104-0.506-0.389-0.506-0.71v-3.3h-4.5c-0.4142 0-0.75-0.336-0.75-0.75v-36c0-0.414 0.3358-0.75 0.75-0.75h24.075c0.315-1.319 1.494-2.25 2.85-2.25h4.65c1.356 0 2.535 0.931 2.85 2.25h24.075c0.414 0 0.75 0.336 0.75 0.75v36c0 0.414-0.336 0.75-0.75 0.75zm-6 2.76v-34.425c-7.335 2.223-15.165 2.223-22.5 0v34.425c7.321 2.32 15.179 2.32 22.5 0zm-46.5 0c7.321 2.32 15.179 2.32 22.5 0v-34.425c-7.335 2.223-15.165 2.223-22.5 0zm51.75-38.76h-24c-0.414 0-0.75-0.336-0.75-0.75v-0.075c0-0.787-0.638-1.425-1.425-1.425h-4.65c-0.787 0-1.425 0.638-1.425 1.425v0.075c0 0.414-0.336 0.75-0.75 0.75h-24v34.5h3.75v-31.2c0-0.414 0.336-0.75 0.75-0.75 0.083 0 0.165 0.013 0.244 0.04 7.631 2.545 15.881 2.545 23.512 0 0.013-2e-3 0.025-4e-3 0.038-6e-3 0.055-0.016 0.112-0.025 0.17-0.028 0.012 0 0.024-6e-3 0.036-6e-3s0.019 4e-3 0.028 4e-3c0.057 2e-3 0.113 0.011 0.168 0.026 0.012 0 0.025 4e-3 0.038 8e-3h0.01c7.631 2.545 15.881 2.545 23.512 0 0.079-0.026 0.161-0.039 0.244-0.038 0.414 0 0.75 0.336 0.75 0.75v31.2h3.75z"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath14318)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-.81084 -.21657 .21657 -.81084 373.53 312.58)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath14328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m65.509 60.259-5.275 5.294c-1.171 1.172-3.07 1.174-4.243 3e-3l-45.078-45.078-4.52-14.112 14.065 4.57 45.049 45.085c1.169 1.171 1.17 3.067 2e-3 4.238zm-14.821-2.124 7.408-7.408-1.602-1.603-7.409 7.409zm-31.082-45.899-8.343-2.7103-1.729 1.7293 2.682 8.376c1.519 1.194 4.182 0.669 6.122-1.27 1.94-1.94 2.465-4.607 1.268-6.125zm-0.208 7.185c-1.341 1.398-3.166 2.23-5.1 2.325l33.727 33.727 7.409-7.407-33.707-33.739c-0.099 1.933-0.932 3.755-2.329 5.094zm45.047 37.661-5.289-5.294-7.408 7.408 5.3 5.3c0.585 0.587 1.535 0.587 2.121 2e-3 1e-3 0 2e-3 -1e-3 2e-3 -2e-3l5.276-5.293c0.585-0.586 0.584-1.536-2e-3 -2.121z"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath14338)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(90.75,377.25)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath14348)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m36.384 7.866c-15.74 0-28.5 12.76-28.5 28.5s12.76 28.5 28.5 28.5 28.5-12.76 28.5-28.5c-0.018-15.733-12.767-28.482-28.5-28.5zm0 55.5c-14.912 0-27-12.088-27-27s12.088-27 27-27 27 12.088 27 27c-0.017 14.905-12.095 26.983-27 27z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46.354 25.336-10.5 10.5c-0.141 0.14-0.22 0.331-0.22 0.53v14.25h1.5v-13.94l10.28-10.28z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.884 55.116c0-0.828-0.672-1.5-1.5-1.5s-1.5 0.672-1.5 1.5 0.672 1.5 1.5 1.5 1.5-0.672 1.5-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.134 36.366c0-0.828-0.672-1.5-1.5-1.5s-1.5 0.672-1.5 1.5 0.672 1.5 1.5 1.5 1.5-0.672 1.5-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.884 17.616c0-0.828-0.672-1.5-1.5-1.5s-1.5 0.672-1.5 1.5 0.672 1.5 1.5 1.5 1.5-0.672 1.5-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.634 36.366c0-0.828-0.672-1.5-1.5-1.5s-1.5 0.672-1.5 1.5 0.672 1.5 1.5 1.5 1.5-0.672 1.5-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.384 11.616c-13.669 0-24.75 11.081-24.75 24.75s11.081 24.75 24.75 24.75 24.75-11.081 24.75-24.75c-0.016-13.663-11.087-24.734-24.75-24.75zm0 48c-12.841 0-23.25-10.409-23.25-23.25s10.409-23.25 23.25-23.25 23.25 10.409 23.25 23.25c-0.015 12.834-10.416 23.235-23.25 23.25z"
  }))))), /*#__PURE__*/React.createElement("path", {
    d: "m207.38 81.375c0 27.755 22.66 50.245 50.62 50.245s50.63-22.49 50.63-50.245c0-27.752-22.67-50.25-50.63-50.25s-50.62 22.498-50.62 50.25z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m207.38 81.375c0 27.755 22.66 50.245 50.62 50.245s50.63-22.49 50.63-50.245c0-27.752-22.67-50.25-50.63-50.25s-50.62 22.498-50.62 50.25z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m329.63 81.375c0 27.755 22.66 50.245 50.62 50.245s50.63-22.49 50.63-50.245c0-27.752-22.67-50.25-50.63-50.25s-50.62 22.498-50.62 50.25z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m329.63 81.375c0 27.755 22.66 50.245 50.62 50.245s50.63-22.49 50.63-50.245c0-27.752-22.67-50.25-50.63-50.25s-50.62 22.498-50.62 50.25z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m457.88 80.25c0 27.96 22.66 50.62 50.62 50.62s50.63-22.66 50.63-50.62c0-27.959-22.67-50.625-50.63-50.625s-50.62 22.666-50.62 50.625z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m457.88 80.25c0 27.96 22.66 50.62 50.62 50.62s50.63-22.66 50.63-50.62c0-27.959-22.67-50.625-50.63-50.625s-50.62 22.666-50.62 50.625z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath14382)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m222.85 56.824-13.48 4.266c-7.45 2.355-12.33 7.935-10.89 12.462 1.43 4.528 8.63 6.288 16.07 3.933l13.49-4.265z",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath14392)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m222.85 56.824-13.48 4.266c-7.45 2.355-12.33 7.935-10.89 12.462 1.43 4.528 8.63 6.288 16.07 3.933l13.49-4.265z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath14402)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m457.42 69.287-13.48 4.265c-7.45 2.356-12.33 7.936-10.9 12.463 1.44 4.528 8.63 6.288 16.08 3.933l13.49-4.266z",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath14412)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m457.42 69.287-13.48 4.265c-7.45 2.356-12.33 7.936-10.9 12.463 1.44 4.528 8.63 6.288 16.08 3.933l13.49-4.266z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath14422)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m234.99 239.96-13.49 4.27c-7.44 2.35-12.32 7.93-10.89 12.46s8.63 6.29 16.08 3.93l13.48-4.26z",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath14432)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m234.99 239.96-13.49 4.27c-7.44 2.35-12.32 7.93-10.89 12.46s8.63 6.29 16.08 3.93l13.48-4.26z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath14442)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m543.68 75.6 7.67 11.878c4.24 6.561 10.91 9.79 14.9 7.213 3.99-2.578 3.78-9.985-0.46-16.545l-7.67-11.879z",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath14452)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m543.68 75.6 7.67 11.878c4.24 6.561 10.91 9.79 14.9 7.213 3.99-2.578 3.78-9.985-0.46-16.545l-7.67-11.879z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath14462)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.8125 0 -7.54e-7 .8125 566.25 86.25)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath14472)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m68.135 23.293-4.056 1.439v6.767l3.261 1.379c0.381 0.162 0.56 0.601 0.399 0.983-0.1 0.237-0.315 0.407-0.569 0.448l-5.353 0.885v6.632l6.348 2.565c0.384 0.155 0.57 0.592 0.415 0.976-0.081 0.2-0.243 0.355-0.445 0.426l-4.056 1.439v6.767l3.261 1.379c0.381 0.162 0.559 0.602 0.398 0.983-0.081 0.191-0.237 0.34-0.431 0.412l-25.17 9.293c-0.162 0.06-0.34 0.062-0.503 6e-3l-33.975-11.849c-0.0709-0.024-0.1377-0.059-0.198-0.103-0.0968-0.075-2.3745-1.808-2.3745-7.13-0.0092-1.213 0.1299-2.422 0.414-3.6-0.8843-0.75-2.664-2.775-2.664-6.9-0.0153-2.969 0.9352-5.862 2.7082-8.243-0.3194-1.226-0.4735-2.49-0.4582-3.757 0-5.279 2.3205-7.425 2.4195-7.513 0.0659-0.06 0.1421-0.107 0.225-0.14l24-9.4443c0.088-0.0342 0.181-0.0517 0.274-0.0517 0.097-2e-4 0.192 0.0184 0.282 0.0547l35.878 14.495c0.384 0.155 0.57 0.592 0.415 0.976-0.081 0.2-0.243 0.355-0.445 0.426zm-7.818 11.775-28.342-11.293-23.742 9.346v6.009l23.501-9.237c0.178-0.071 0.377-0.071 0.556 0l28.026 11.325zm-28.311-26.169-23.572 9.2743c-0.366 0.408-1.8457 2.306-1.8457 6.317-0.0215 1.252 0.1487 2.5 0.5047 3.701 0.0812 0.255 0.0203 0.534-0.1597 0.732-1.7037 2.153-2.6194 4.824-2.595 7.57 0 4.458 2.3047 5.902 2.4 5.958 0.3001 0.174 0.4419 0.531 0.3427 0.864-0.3393 1.195-0.5045 2.433-0.4905 3.675 0 3.987 1.3883 5.56 1.7018 5.865l33.577 11.711 23.123-8.538c0.01 0 0.01-0.011 0-0.014l-32.986-13.365-21.999 8.659c-0.3853 0.152-0.8206-0.038-0.9722-0.423-0.0344-0.088-0.0521-0.181-0.0521-0.275v-7.5c1e-4 -0.308 0.1884-0.584 0.4748-0.698l22.276-8.769c0.178-0.071 0.377-0.071 0.556 0l30.693 12.405 2.768-1c0.01-4e-3 0.01-0.01 0-0.014l-33.745-13.635-24.249 9.529c-0.3854 0.152-0.8208-0.038-0.9724-0.423-0.0344-0.088-0.0521-0.181-0.0521-0.275v-7.62c1e-4 -0.308 0.1884-0.584 0.4748-0.698l24.494-9.642c0.177-0.07 0.374-0.07 0.552 0l28.896 11.513 3.194-0.525c0.014 0 0.015-9e-3 0-0.014l-32.338-13.095-21.999 8.659c-0.3853 0.152-0.8206-0.038-0.9722-0.423-0.0344-0.088-0.0521-0.181-0.0521-0.275v-7.5c1e-4 -0.308 0.1884-0.584 0.4748-0.698l22.276-8.769c0.178-0.071 0.377-0.071 0.556 0l30.693 12.405 2.768-1c0.01 0 0.01-0.01 0-0.014zm30.573 38.603-30.573-12.353-21.525 8.475v5.887l21.253-8.368c0.178-0.071 0.377-0.071 0.556 0l30.289 12.241zm0-22.5-30.573-12.353-21.525 8.475v5.887l21.253-8.368c0.178-0.071 0.377-0.071 0.556 0l30.289 12.241z"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath14482)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(413.25,73.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath14492)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m42.384 46.866h11.25v1.5h-11.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.384 42.366h11.25v1.5h-11.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.384 37.866h7.5v1.5h-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m65.634 54.366h-4.5v3.3c0 0.32-0.203 0.605-0.506 0.709-7.864 2.625-16.363 2.654-24.244 0.083-7.881 2.572-16.38 2.543-24.244-0.082-0.303-0.104-0.506-0.389-0.506-0.71v-3.3h-4.5c-0.4142 0-0.75-0.336-0.75-0.75v-36c0-0.414 0.3358-0.75 0.75-0.75h24.075c0.315-1.319 1.494-2.25 2.85-2.25h4.65c1.356 0 2.535 0.931 2.85 2.25h24.075c0.414 0 0.75 0.336 0.75 0.75v36c0 0.414-0.336 0.75-0.75 0.75zm-6 2.76v-34.425c-7.335 2.223-15.165 2.223-22.5 0v34.425c7.321 2.32 15.179 2.32 22.5 0zm-46.5 0c7.321 2.32 15.179 2.32 22.5 0v-34.425c-7.335 2.223-15.165 2.223-22.5 0zm51.75-38.76h-24c-0.414 0-0.75-0.336-0.75-0.75v-0.075c0-0.787-0.638-1.425-1.425-1.425h-4.65c-0.787 0-1.425 0.638-1.425 1.425v0.075c0 0.414-0.336 0.75-0.75 0.75h-24v34.5h3.75v-31.2c0-0.414 0.336-0.75 0.75-0.75 0.083 0 0.165 0.013 0.244 0.04 7.631 2.545 15.881 2.545 23.512 0 0.013-2e-3 0.025-4e-3 0.038-6e-3 0.055-0.016 0.112-0.025 0.17-0.028 0.012 0 0.024-6e-3 0.036-6e-3s0.019 4e-3 0.028 4e-3c0.057 2e-3 0.113 0.011 0.168 0.026 0.012 0 0.025 4e-3 0.038 8e-3h0.01c7.631 2.545 15.881 2.545 23.512 0 0.079-0.026 0.161-0.039 0.244-0.038 0.414 0 0.75 0.336 0.75 0.75v31.2h3.75z"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath14508)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(286.5,77.25)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath14518)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m42.384 46.866h11.25v1.5h-11.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.384 42.366h11.25v1.5h-11.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.384 37.866h7.5v1.5h-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m65.634 54.366h-4.5v3.3c0 0.32-0.203 0.605-0.506 0.709-7.864 2.625-16.363 2.654-24.244 0.083-7.881 2.572-16.38 2.543-24.244-0.082-0.303-0.104-0.506-0.389-0.506-0.71v-3.3h-4.5c-0.4142 0-0.75-0.336-0.75-0.75v-36c0-0.414 0.3358-0.75 0.75-0.75h24.075c0.315-1.319 1.494-2.25 2.85-2.25h4.65c1.356 0 2.535 0.931 2.85 2.25h24.075c0.414 0 0.75 0.336 0.75 0.75v36c0 0.414-0.336 0.75-0.75 0.75zm-6 2.76v-34.425c-7.335 2.223-15.165 2.223-22.5 0v34.425c7.321 2.32 15.179 2.32 22.5 0zm-46.5 0c7.321 2.32 15.179 2.32 22.5 0v-34.425c-7.335 2.223-15.165 2.223-22.5 0zm51.75-38.76h-24c-0.414 0-0.75-0.336-0.75-0.75v-0.075c0-0.787-0.638-1.425-1.425-1.425h-4.65c-0.787 0-1.425 0.638-1.425 1.425v0.075c0 0.414-0.336 0.75-0.75 0.75h-24v34.5h3.75v-31.2c0-0.414 0.336-0.75 0.75-0.75 0.083 0 0.165 0.013 0.244 0.04 7.631 2.545 15.881 2.545 23.512 0 0.013-2e-3 0.025-4e-3 0.038-6e-3 0.055-0.016 0.112-0.025 0.17-0.028 0.012 0 0.024-6e-3 0.036-6e-3s0.019 4e-3 0.028 4e-3c0.057 2e-3 0.113 0.011 0.168 0.026 0.012 0 0.025 4e-3 0.038 8e-3h0.01c7.631 2.545 15.881 2.545 23.512 0 0.079-0.026 0.161-0.039 0.244-0.038 0.414 0 0.75 0.336 0.75 0.75v31.2h3.75z"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath14534)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(165,71.25)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath14544)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m42.384 46.866h11.25v1.5h-11.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.384 42.366h11.25v1.5h-11.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.384 37.866h7.5v1.5h-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m65.634 54.366h-4.5v3.3c0 0.32-0.203 0.605-0.506 0.709-7.864 2.625-16.363 2.654-24.244 0.083-7.881 2.572-16.38 2.543-24.244-0.082-0.303-0.104-0.506-0.389-0.506-0.71v-3.3h-4.5c-0.4142 0-0.75-0.336-0.75-0.75v-36c0-0.414 0.3358-0.75 0.75-0.75h24.075c0.315-1.319 1.494-2.25 2.85-2.25h4.65c1.356 0 2.535 0.931 2.85 2.25h24.075c0.414 0 0.75 0.336 0.75 0.75v36c0 0.414-0.336 0.75-0.75 0.75zm-6 2.76v-34.425c-7.335 2.223-15.165 2.223-22.5 0v34.425c7.321 2.32 15.179 2.32 22.5 0zm-46.5 0c7.321 2.32 15.179 2.32 22.5 0v-34.425c-7.335 2.223-15.165 2.223-22.5 0zm51.75-38.76h-24c-0.414 0-0.75-0.336-0.75-0.75v-0.075c0-0.787-0.638-1.425-1.425-1.425h-4.65c-0.787 0-1.425 0.638-1.425 1.425v0.075c0 0.414-0.336 0.75-0.75 0.75h-24v34.5h3.75v-31.2c0-0.414 0.336-0.75 0.75-0.75 0.083 0 0.165 0.013 0.244 0.04 7.631 2.545 15.881 2.545 23.512 0 0.013-2e-3 0.025-4e-3 0.038-6e-3 0.055-0.016 0.112-0.025 0.17-0.028 0.012 0 0.024-6e-3 0.036-6e-3s0.019 4e-3 0.028 4e-3c0.057 2e-3 0.113 0.011 0.168 0.026 0.012 0 0.025 4e-3 0.038 8e-3h0.01c7.631 2.545 15.881 2.545 23.512 0 0.079-0.026 0.161-0.039 0.244-0.038 0.414 0 0.75 0.336 0.75 0.75v31.2h3.75z"
  }))))), /*#__PURE__*/React.createElement("path", {
    d: "m265.41 274.61h-3.2c-0.23 0-0.45-0.04-0.66-0.12l-0.32-0.11 0.53 0.11-0.4-0.03c-0.2-0.01-0.39-0.06-0.58-0.13l-0.28-0.12 0.72 0.14h-0.54c-0.27 0-0.54-0.05-0.79-0.17l-0.26-0.11 0.58 0.16-0.25-0.03c-0.72-0.08-1.33-0.55-1.6-1.21l-0.06-0.15c-0.24-0.6-0.16-1.28 0.2-1.81 0.36-0.54 0.97-0.86 1.61-0.86h1.36l-0.79 0.17 0.26-0.11c0.18-0.09 0.38-0.14 0.57-0.16l0.26-0.03-1 0.42 0.28-0.23c0.29-0.23 0.64-0.37 1-0.42l0.26-0.02-0.58 0.15 0.26-0.11 0.06-0.03 0.29-0.11c0.16-0.07 0.33-0.11 0.51-0.13l0.25-0.03-0.73 0.23 0.26-0.14c0.29-0.16 0.61-0.24 0.94-0.24h0.26l-1.22 0.42 0.14-0.11c0.28-0.22 0.62-0.37 0.98-0.41l0.22-0.03-0.97 0.41 0.14-0.11c0.35-0.28 0.78-0.43 1.22-0.43h0.88c0.19 0 0.39 0.03 0.58 0.09l0.45 0.14-0.04-0.01 0.59 0.17-0.17-0.04 0.74 0.14c0.14 0.03 0.28 0.07 0.41 0.13l0.65 0.28-0.42-0.13 0.91 0.17 0.35 0.1 0.8 0.32-0.12-0.04 0.97 0.31-0.13-0.04 0.8 0.2 0.09 0.03 0.93 0.28-0.49-0.08 0.79 0.02c0.2 0.01 0.4 0.05 0.59 0.12l0.79 0.28-0.58-0.11 0.74 0.03 0.37 0.05 0.6 0.14-0.09-0.02 0.6 0.11-0.17-0.02 0.56 0.06 0.17 0.02 0.6 0.11-0.36-0.03h0.45c0.18 0 0.36 0.03 0.53 0.08l0.4 0.11-0.11-0.03 0.25 0.06 0.3 0.09 0.29 0.11-0.73-0.14h1.59c0.44 0 0.87 0.15 1.22 0.43l0.14 0.11-0.97-0.41 0.22 0.03c0.36 0.05 0.7 0.19 0.98 0.41l0.14 0.12-1.22-0.43h0.77c0.51 0 1.01 0.2 1.38 0.57l0.11 0.11-1.16-0.56 0.25 0.03c0.44 0.05 0.85 0.25 1.16 0.56l0.15 0.14-1.38-0.57h0.54c0.44 0 0.87 0.15 1.21 0.43l0.15 0.11-0.98-0.41 0.23 0.03c0.35 0.04 0.69 0.19 0.97 0.41l0.14 0.11-0.49-0.28 0.28 0.11-0.51-0.13 0.26 0.03c0.26 0.03 0.51 0.11 0.73 0.23l0.26 0.15-0.95-0.25h0.51c0.44 0 0.87 0.15 1.22 0.43l0.14 0.11-0.98-0.41 0.23 0.03c0.43 0.05 0.83 0.25 1.14 0.55l0.11 0.12-2.6-0.15 0.15-0.11-0.16 0.14 0.11-0.11-0.57 1.38v-0.48l0.43 1.21-0.12-0.14c-0.22-0.28-0.37-0.62-0.41-0.97l-0.03-0.23 1.69 1.69-0.22-0.03c-0.3-0.03-0.59-0.14-0.84-0.31l-0.17-0.11 1.08 0.32h-0.26c-0.44 0-0.87-0.15-1.21-0.42l-0.15-0.12 1.01 0.42-0.26-0.03c-0.37-0.04-0.71-0.18-1-0.41l-0.14-0.12 1.21 0.43h-0.28c-0.52 0-1.01-0.21-1.38-0.57l-0.14-0.14 1.14 0.55-0.23-0.03c-0.36-0.04-0.69-0.18-0.97-0.41l-0.15-0.11 1.22 0.43h-0.28c-0.44 0-0.87-0.15-1.22-0.43l-0.14-0.11 0.97 0.41-0.22-0.03c-0.36-0.05-0.7-0.19-0.98-0.41l-0.14-0.12-0.14-0.11 0.97 0.41-0.22-0.03c-0.89-0.11-1.58-0.8-1.69-1.69l-0.03-0.22 1.69 1.69-0.23-0.03c-0.88-0.11-1.58-0.81-1.69-1.69l-0.03-0.23 1.69 1.69-0.22-0.03c-0.89-0.11-1.58-0.8-1.7-1.69l-0.02-0.22 1.69 1.69-0.23-0.03c-0.87-0.11-1.56-0.79-1.69-1.66l-0.02-0.2-0.02-0.27v-0.03c0-0.59 0.27-1.15 0.73-1.52l0.14-0.12c0.35-0.27 0.77-0.42 1.22-0.42h2.43c1.08 0 1.95 0.87 1.95 1.95 0 1.07-0.87 1.94-1.95 1.94h-2.43l1.21-0.42-0.14 0.11 0.73-1.52v0.03l-0.02-0.28 0.03 0.2-1.68-1.66 0.22 0.03c0.89 0.11 1.58 0.81 1.69 1.69l0.03 0.23-1.69-1.69 0.23 0.03c0.88 0.11 1.58 0.8 1.69 1.69l0.03 0.22-1.69-1.69 0.22 0.03c0.89 0.11 1.58 0.81 1.69 1.69l0.03 0.23-1.69-1.69 0.23 0.03c0.35 0.04 0.69 0.18 0.97 0.41l0.14 0.11 0.15 0.11-0.98-0.41 0.23 0.03c0.35 0.05 0.69 0.19 0.97 0.41l0.15 0.12-1.22-0.43h0.28c0.44 0 0.87 0.15 1.22 0.43l0.14 0.11-0.98-0.41 0.23 0.03c0.43 0.05 0.83 0.24 1.14 0.55l0.14 0.14-1.38-0.57h0.28c0.45 0 0.88 0.15 1.22 0.43l0.14 0.11-1-0.41 0.26 0.03c0.36 0.04 0.71 0.18 1 0.41l0.14 0.11-1.22-0.42h0.26c0.38 0 0.76 0.11 1.08 0.32l0.17 0.12-0.84-0.31 0.23 0.02c0.88 0.11 1.58 0.81 1.69 1.7l0.03 0.22-0.41-0.97 0.11 0.14c0.28 0.34 0.43 0.77 0.43 1.22v0.48c0 0.52-0.21 1.01-0.57 1.38l-0.12 0.11-0.16 0.14-0.14 0.12c-0.78 0.62-1.89 0.56-2.6-0.15l-0.11-0.11 1.14 0.56-0.23-0.03c-0.36-0.05-0.69-0.19-0.98-0.41l-0.14-0.12 1.22 0.43h-0.51c-0.33 0-0.66-0.09-0.95-0.25l-0.25-0.14 0.73 0.24-0.26-0.03c-0.17-0.02-0.34-0.07-0.5-0.13l-0.29-0.11c-0.18-0.08-0.34-0.17-0.49-0.29l-0.14-0.12 0.97 0.42-0.22-0.03c-0.36-0.05-0.7-0.19-0.98-0.41l-0.14-0.12 1.22 0.43h-0.54c-0.52 0-1.02-0.21-1.38-0.57l-0.14-0.14 1.16 0.56-0.25-0.03c-0.44-0.05-0.85-0.25-1.17-0.56l-0.11-0.11 1.38 0.57h-0.77c-0.44 0-0.87-0.15-1.22-0.43l-0.14-0.11 0.98 0.41-0.23-0.03c-0.36-0.04-0.69-0.19-0.97-0.41l-0.15-0.12 1.22 0.43h-1.59c-0.24 0-0.49-0.05-0.72-0.14l-0.28-0.11 0.3 0.09-0.26-0.05-0.11-0.03-0.4-0.12 0.54 0.08h-0.45l-0.37-0.04-0.59-0.11 0.17 0.02-0.57-0.05-0.17-0.03-0.6-0.11-0.08-0.02-0.6-0.14 0.38 0.05-0.74-0.03c-0.2 0-0.39-0.04-0.58-0.11l-0.79-0.28 0.58 0.11-0.79-0.03c-0.17 0-0.34-0.03-0.5-0.08l-0.93-0.28 0.09 0.02-0.79-0.2-0.13-0.03-1.08-0.36-0.79-0.31 0.35 0.1-0.9-0.17c-0.15-0.02-0.29-0.07-0.42-0.12l-0.65-0.29 0.4 0.13-0.73-0.14-0.17-0.04-0.6-0.17-0.04-0.02-0.45-0.14 0.58 0.09h-0.88l1.22-0.43-0.15 0.12c-0.28 0.22-0.62 0.36-0.97 0.41l-0.23 0.03 0.98-0.42-0.15 0.12c-0.34 0.27-0.77 0.43-1.21 0.43h-0.26l0.95-0.25-0.26 0.14c-0.22 0.13-0.47 0.21-0.73 0.24l-0.25 0.02 0.51-0.12-0.29 0.11 0.07-0.03-0.25 0.11c-0.19 0.09-0.38 0.14-0.58 0.16l-0.26 0.03 1.01-0.42-0.29 0.23c-0.29 0.23-0.63 0.37-1 0.42l-0.25 0.02 0.57-0.15-0.25 0.11c-0.25 0.11-0.52 0.17-0.8 0.17h-1.36c-0.98 0-1.8-0.73-1.93-1.7-0.12-0.98 0.5-1.89 1.45-2.14 0.94-0.24 1.93 0.26 2.29 1.17l0.06 0.14-1.59-1.22 0.25 0.03c0.2 0.03 0.39 0.08 0.58 0.16l0.25 0.11-0.79-0.17h0.54c0.25 0 0.49 0.05 0.72 0.14l0.29 0.12-0.59-0.14 0.4 0.03c0.18 0.01 0.36 0.05 0.53 0.11l0.31 0.12-0.67-0.12h3.2c1.08 0 1.95 0.87 1.95 1.95 0 1.07-0.87 1.95-1.95 1.95z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m264.95 267.39c0-1.08-0.87-1.95-1.95-1.95s-1.95 0.87-1.95 1.95 0.87 1.95 1.95 1.95 1.95-0.87 1.95-1.95z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m281.53 267.39c0-1.08-0.87-1.95-1.95-1.95-1.07 0-1.95 0.87-1.95 1.95s0.88 1.95 1.95 1.95c1.08 0 1.95-0.87 1.95-1.95z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath14566)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m330.35 69.785-9.01 10.902c-4.98 6.02-6.05 13.353-2.38 16.378 3.66 3.025 10.66 0.597 15.63-5.424l9.01-10.902z",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath14576)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m330.35 69.785-9.01 10.902c-4.98 6.02-6.05 13.353-2.38 16.378 3.66 3.025 10.66 0.597 15.63-5.424l9.01-10.902z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath14586)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(533.25,-5.9999)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath14596)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m58.134 34.116h-0.75v15.75c-5e-3 4.554-3.696 8.245-8.25 8.25h-3.038c-0.406 5.364-5.083 9.384-10.447 8.978-4.8-0.363-8.615-4.178-8.978-8.978h-3.037c-4.554-5e-3 -8.245-3.696-8.25-8.25v-15.75h-0.75c-2.07-2e-3 -3.748-1.68-3.75-3.75v-10.5c2e-3 -2.07 1.68-3.748 3.75-3.75h0.75v-1.5c3e-3 -2.898 2.352-5.2467 5.25-5.25h33c2.07 0.0025 3.748 1.68 3.75 3.75v3h0.75c2.07 2e-3 3.748 1.68 3.75 3.75v10.5c-2e-3 2.07-1.68 3.748-3.75 3.75zm-21.75 31.5c4.263-6e-3 7.821-3.255 8.212-7.5h-16.425c0.391 4.245 3.95 7.495 8.213 7.5zm12.75-9c0.251-1e-3 0.501-0.015 0.75-0.044v-12.706c0-1.243-1.007-2.25-2.25-2.25h-8.25v1.5c0 1.243-1.007 2.25-2.25 2.25h-1.5c-1.243 0-2.25-1.007-2.25-2.25v-1.5h-8.25c-1.243 0-2.25 1.007-2.25 2.25v12.706c0.249 0.029 0.499 0.043 0.75 0.044zm-11.25-13.5v-4.5c0-0.414-0.336-0.75-0.75-0.75h-1.5c-0.414 0-0.75 0.336-0.75 0.75v4.5c0 0.414 0.336 0.75 0.75 0.75h1.5c0.414 0 0.75-0.336 0.75-0.75zm-23.25-25.5c-1.243 0-2.25 1.007-2.25 2.25v10.5c0 1.243 1.007 2.25 2.25 2.25h0.75v-15zm33-6.75h-22.5v8.25c0 1.243 1.007 2.25 2.25 2.25h18c1.243 0 2.25-1.007 2.25-2.25zm8.25 2.25c0-1.243-1.007-2.25-2.25-2.25h-4.5v8.25c-2e-3 2.07-1.68 3.748-3.75 3.75h-18c-2.07-2e-3 -3.748-1.68-3.75-3.75v-8.25h-3c-2.07 2e-3 -3.748 1.68-3.75 3.75v35.25c5e-3 2.857 1.807 5.402 4.5 6.356v-12.356c2e-3 -2.07 1.68-3.748 3.75-3.75h8.25v-1.5c0-1.243 1.007-2.25 2.25-2.25h1.5c1.243 0 2.25 1.007 2.25 2.25v1.5h8.25c2.07 2e-3 3.748 1.68 3.75 3.75v12.356c2.693-0.954 4.495-3.499 4.5-6.356zm4.5 6.75c0-1.243-1.007-2.25-2.25-2.25h-0.75v15h0.75c1.243 0 2.25-1.007 2.25-2.25z"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath14606)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-9.0578 316.87 -3687.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath14616)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m58.134 34.116h-0.75v15.75c-5e-3 4.554-3.696 8.245-8.25 8.25h-3.038c-0.406 5.364-5.083 9.384-10.447 8.978-4.8-0.363-8.615-4.178-8.978-8.978h-3.037c-4.554-5e-3 -8.245-3.696-8.25-8.25v-15.75h-0.75c-2.07-2e-3 -3.748-1.68-3.75-3.75v-10.5c2e-3 -2.07 1.68-3.748 3.75-3.75h0.75v-1.5c3e-3 -2.898 2.352-5.2467 5.25-5.25h33c2.07 0.0025 3.748 1.68 3.75 3.75v3h0.75c2.07 2e-3 3.748 1.68 3.75 3.75v10.5c-2e-3 2.07-1.68 3.748-3.75 3.75zm-21.75 31.5c4.263-6e-3 7.821-3.255 8.212-7.5h-16.425c0.391 4.245 3.95 7.495 8.213 7.5zm12.75-9c0.251-1e-3 0.501-0.015 0.75-0.044v-12.706c0-1.243-1.007-2.25-2.25-2.25h-8.25v1.5c0 1.243-1.007 2.25-2.25 2.25h-1.5c-1.243 0-2.25-1.007-2.25-2.25v-1.5h-8.25c-1.243 0-2.25 1.007-2.25 2.25v12.706c0.249 0.029 0.499 0.043 0.75 0.044zm-11.25-13.5v-4.5c0-0.414-0.336-0.75-0.75-0.75h-1.5c-0.414 0-0.75 0.336-0.75 0.75v4.5c0 0.414 0.336 0.75 0.75 0.75h1.5c0.414 0 0.75-0.336 0.75-0.75zm-23.25-25.5c-1.243 0-2.25 1.007-2.25 2.25v10.5c0 1.243 1.007 2.25 2.25 2.25h0.75v-15zm33-6.75h-22.5v8.25c0 1.243 1.007 2.25 2.25 2.25h18c1.243 0 2.25-1.007 2.25-2.25zm8.25 2.25c0-1.243-1.007-2.25-2.25-2.25h-4.5v8.25c-2e-3 2.07-1.68 3.748-3.75 3.75h-18c-2.07-2e-3 -3.748-1.68-3.75-3.75v-8.25h-3c-2.07 2e-3 -3.748 1.68-3.75 3.75v35.25c5e-3 2.857 1.807 5.402 4.5 6.356v-12.356c2e-3 -2.07 1.68-3.748 3.75-3.75h8.25v-1.5c0-1.243 1.007-2.25 2.25-2.25h1.5c1.243 0 2.25 1.007 2.25 2.25v1.5h8.25c2.07 2e-3 3.748 1.68 3.75 3.75v12.356c2.693-0.954 4.495-3.499 4.5-6.356zm4.5 6.75c0-1.243-1.007-2.25-2.25-2.25h-0.75v15h0.75c1.243 0 2.25-1.007 2.25-2.25z"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath14626)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(116.25,-4.4999)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath14636)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m58.134 34.116h-0.75v15.75c-5e-3 4.554-3.696 8.245-8.25 8.25h-3.038c-0.406 5.364-5.083 9.384-10.447 8.978-4.8-0.363-8.615-4.178-8.978-8.978h-3.037c-4.554-5e-3 -8.245-3.696-8.25-8.25v-15.75h-0.75c-2.07-2e-3 -3.748-1.68-3.75-3.75v-10.5c2e-3 -2.07 1.68-3.748 3.75-3.75h0.75v-1.5c3e-3 -2.898 2.352-5.2467 5.25-5.25h33c2.07 0.0025 3.748 1.68 3.75 3.75v3h0.75c2.07 2e-3 3.748 1.68 3.75 3.75v10.5c-2e-3 2.07-1.68 3.748-3.75 3.75zm-21.75 31.5c4.263-6e-3 7.821-3.255 8.212-7.5h-16.425c0.391 4.245 3.95 7.495 8.213 7.5zm12.75-9c0.251-1e-3 0.501-0.015 0.75-0.044v-12.706c0-1.243-1.007-2.25-2.25-2.25h-8.25v1.5c0 1.243-1.007 2.25-2.25 2.25h-1.5c-1.243 0-2.25-1.007-2.25-2.25v-1.5h-8.25c-1.243 0-2.25 1.007-2.25 2.25v12.706c0.249 0.029 0.499 0.043 0.75 0.044zm-11.25-13.5v-4.5c0-0.414-0.336-0.75-0.75-0.75h-1.5c-0.414 0-0.75 0.336-0.75 0.75v4.5c0 0.414 0.336 0.75 0.75 0.75h1.5c0.414 0 0.75-0.336 0.75-0.75zm-23.25-25.5c-1.243 0-2.25 1.007-2.25 2.25v10.5c0 1.243 1.007 2.25 2.25 2.25h0.75v-15zm33-6.75h-22.5v8.25c0 1.243 1.007 2.25 2.25 2.25h18c1.243 0 2.25-1.007 2.25-2.25zm8.25 2.25c0-1.243-1.007-2.25-2.25-2.25h-4.5v8.25c-2e-3 2.07-1.68 3.748-3.75 3.75h-18c-2.07-2e-3 -3.748-1.68-3.75-3.75v-8.25h-3c-2.07 2e-3 -3.748 1.68-3.75 3.75v35.25c5e-3 2.857 1.807 5.402 4.5 6.356v-12.356c2e-3 -2.07 1.68-3.748 3.75-3.75h8.25v-1.5c0-1.243 1.007-2.25 2.25-2.25h1.5c1.243 0 2.25 1.007 2.25 2.25v1.5h8.25c2.07 2e-3 3.748 1.68 3.75 3.75v12.356c2.693-0.954 4.495-3.499 4.5-6.356zm4.5 6.75c0-1.243-1.007-2.25-2.25-2.25h-0.75v15h0.75c1.243 0 2.25-1.007 2.25-2.25z"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg22);
export default __webpack_public_path__ + "static/media/22.539711d660c29633218ec01f5cbcf2b1.svg";
export { ForwardRef as ReactComponent };